var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64715 6.35285C8.18875 5.89459 7.56711 5.63715 6.91893 5.63715C6.27075 5.63715 5.64911 5.89459 5.1907 6.35285L2.74626 8.7973C2.51279 9.02279 2.32657 9.29252 2.19846 9.59075C2.07035 9.88898 2.00291 10.2097 2.00009 10.5343C1.99727 10.8589 2.05912 11.1808 2.18203 11.4812C2.30494 11.7816 2.48645 12.0545 2.71596 12.284C2.94548 12.5136 3.2184 12.6951 3.51882 12.818C3.81923 12.9409 4.14111 13.0027 4.46569 12.9999C4.79026 12.9971 5.11102 12.9297 5.40925 12.8015C5.70748 12.6734 5.97721 12.4872 6.2027 12.2537L6.87615 11.5809M6.41293 8.58707C6.87133 9.04534 7.49297 9.30277 8.14115 9.30277C8.78933 9.30277 9.41097 9.04534 9.86937 8.58707L12.3138 6.14263C12.7591 5.6816 13.0055 5.06413 12.9999 4.4232C12.9943 3.78228 12.7373 3.16918 12.284 2.71596C11.8308 2.26274 11.2177 2.00566 10.5768 2.00009C9.93587 1.99452 9.3184 2.24091 8.85737 2.68618L8.18515 3.35841",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11L13 15",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13L11 13",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateLink);
export default __webpack_public_path__ + "static/media/create-link.1ffa2487524e160f34ae7d1fea246d7b.svg";
export { ForwardRef as ReactComponent };